(() => {
  if (customElements.get('sf-complementary-products')) return;
  class SoulFeBundlePicker extends HTMLElement {
    async connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.busy = false;
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', { style: 'currency', currency: window.Shopify?.currency?.active || 'BRL' });
      const current = this.querySelector('[data-pw-current-template]')?.content.firstElementChild?.cloneNode(true);
      const count = Math.max(2, Number(this.dataset.recommendationsCount) || 3);
      try {
        const pool = await this.fetchSource('affinity');
        const family = this.dataset.affinity;
        const collect = source => source ? [...source.querySelectorAll('[data-pw-item]')].filter(row => row.dataset.productId !== this.dataset.productId && (family === 'generic' || row.dataset.affinity === family)) : [];
        let rows = collect(pool);
        if (rows.length < count) rows.push(...collect(await this.fetchSource('complementary')));
        if (rows.length < count && this.dataset.fallbackRelated !== 'false') rows.push(...collect(await this.fetchSource('related')));
        rows = [...new Map(rows.map(row => [row.dataset.productId, row])).values()];
        const kind = name => ['bracelete','colar','terco','brinco','anel','pulseira'].find(word => (name || '').includes(word)) || '';
        const currentKind = kind(this.dataset.productName);
        rows.sort((a,b) => Number(kind(a.dataset.productName) === currentKind) - Number(kind(b.dataset.productName) === currentKind));
        rows = rows.slice(0, count).map(row => row.cloneNode(true));
        if (!rows.length) { this.hidden = true; return; }
        if (current) rows.unshift(current);
        this.innerHTML = '<h2 class="sf-bundle-heading"></h2><p class="sf-bundle-intro">Selecione as peças que você quer levar.</p><ul class="sf-bundle-items" role="list"></ul><div class="sf-bundle-subtotal">Subtotal <strong data-pw-subtotal></strong><s data-pw-subtotal-compare hidden></s></div><p class="sf-bundle-note">Leve 3, pague 2: a peça de menor valor fica grátis no carrinho.</p><button type="button" class="sf-bundle-add" data-pw-add-items>ADICIONAR ITENS</button><p class="sf-bundle-status" role="status" aria-live="polite"></p>';
        this.querySelector('h2').textContent = this.dataset.pickerTitle || 'Compre junto';
        this.querySelector('ul').replaceChildren(...rows);
        this.form = document.querySelector('.product__info form[is="product-form"]');
        this.variantChanged = event => this.syncCurrent(event.detail?.variant);
        this.form?.addEventListener('variant:changed', this.variantChanged);
        this.quantityChanged = event => { if (event.target.name === 'quantity' && event.target.form === this.form) this.updateSubtotal(); };
        document.addEventListener('change', this.quantityChanged);
        this.addEventListener('change', event => {
          if (event.target.matches('[data-pw-variant-select]')) this.selectVariant(event.target.closest('[data-pw-item]'));
          this.updateSubtotal();
        });
        this.querySelector('[data-pw-add-items]').addEventListener('click', () => this.addItems());
        rows.forEach(row => this.selectVariant(row));
        this.updateSubtotal();
        this.hidden = false;
      } catch (error) {
        console.warn('Soul Fé: não foi possível carregar a seleção de peças', error);
        this.hidden = true;
      }
    }
    disconnectedCallback() {
      this.form?.removeEventListener('variant:changed', this.variantChanged);
      if (this.quantityChanged) document.removeEventListener('change', this.quantityChanged);
    }
    async fetchSource(intent) {
      let url;
      if (intent === 'affinity') {
        if (this.dataset.affinityEnabled === 'false' || !this.dataset.affinityCollection) return null;
        url = new URL(this.dataset.affinityCollection, location.origin);
        url.searchParams.set('section_id', 'sf-pair-candidates'); url.searchParams.set('sort_by', 'best-selling');
      } else {
        url = new URL(this.dataset.recommendationsUrl, location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId); url.searchParams.set('product_id', this.dataset.productId);
        url.searchParams.set('limit', '10'); url.searchParams.set('intent', intent);
      }
      try {
        const response = await fetch(url, { credentials: 'same-origin' }); if (!response.ok) return null;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        return doc.querySelector(intent === 'affinity' ? '[data-sf-pair-pool]' : 'sf-complementary-products');
      } catch { return null; }
    }
    selectVariant(row) {
      const select = row.querySelector('select'); const option = select?.selectedOptions[0];
      if (option) {
        row.dataset.variantId = option.value; row.dataset.price = option.dataset.price; row.dataset.compare = option.dataset.compare;
        if (option.dataset.image) { const image = row.querySelector('img'); image.src = option.dataset.image; image.removeAttribute('srcset'); }
      }
      const price = Number(row.dataset.price); const compare = Number(row.dataset.compare);
      row.querySelector('[data-pw-price]').textContent = this.money.format(price / 100);
      const old = row.querySelector('[data-pw-compare]'); old.textContent = this.money.format(compare / 100); old.hidden = compare <= price;
    }
    syncCurrent(variant) {
      const row = this.querySelector('[data-pw-current]'); if (!row || !variant) return;
      row.dataset.variantId = String(variant.id); row.dataset.price = String(variant.price); row.dataset.compare = String(variant.compare_at_price || variant.price);
      const checkbox = row.querySelector('[data-pw-choice]'); checkbox.disabled = !variant.available; if (!variant.available) checkbox.checked = false;
      const select = row.querySelector('select'); if (select && [...select.options].some(option => option.value === String(variant.id))) select.value = String(variant.id);
      if (variant.featured_image?.src) { const image = row.querySelector('img'); image.src = variant.featured_image.src; image.removeAttribute('srcset'); }
      if (variant.available) this.selectVariant(row);
      else row.querySelector('[data-pw-price]').textContent = this.money.format(variant.price / 100);
      this.updateSubtotal();
    }
    updateSubtotal() {
      let subtotal = 0, compare = 0, count = 0;
      this.querySelectorAll('[data-pw-item]').forEach(row => {
        if (row.hasAttribute('data-pw-current')) {
          const input = this.form && [...this.form.elements].find(element => element.name === 'quantity' && element.type !== 'hidden');
          row.dataset.quantity = String(Math.max(1, Math.floor(Number(input?.value) || 1)));
          const quantity = Number(row.dataset.quantity); const label = row.querySelector('[data-pw-quantity-label]'); label.hidden = quantity === 1; label.textContent = `Quantidade: ${quantity}`;
        }
        const selected = row.querySelector('[data-pw-choice]');
        if (!selected.checked || selected.disabled) return;
        const quantity = Number(row.dataset.quantity) || 1, price = Number(row.dataset.price);
        subtotal += price * quantity; compare += Math.max(price, Number(row.dataset.compare) || price) * quantity; count += quantity;
      });
      this.dataset.subtotal = String(subtotal); this.dataset.selectedCount = String(count);
      this.querySelector('[data-pw-subtotal]').textContent = this.money.format(subtotal / 100);
      const previous = this.querySelector('[data-pw-subtotal-compare]'); previous.textContent = this.money.format(compare / 100); previous.hidden = compare <= subtotal;
      this.querySelector('[data-pw-add-items]').disabled = count === 0 || this.busy;
    }
    async addItems() {
      if (this.busy) return;
      this.updateSubtotal();
      const items = [...this.querySelectorAll('[data-pw-item]')].filter(row => { const check = row.querySelector('[data-pw-choice]'); return check.checked && !check.disabled; }).map(row => ({ id: Number(row.dataset.variantId), quantity: Number(row.dataset.quantity) || 1 }));
      if (!items.length) return;
      const button = this.querySelector('[data-pw-add-items]'), status = this.querySelector('.sf-bundle-status');
      this.busy = true; button.disabled = true; button.setAttribute('aria-busy','true'); button.textContent = 'ADICIONANDO…'; status.textContent = '';
      let added = false;
      try {
        const response = await fetch(this.dataset.cartAddUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({items,sections:['mini-cart'],sections_url:location.pathname}) });
        const result = await response.json().catch(() => null); if (!response.ok || !result) throw Error(result?.description || 'Não foi possível adicionar os itens. Tente novamente em instantes.');
        added = true;
        const cartResponse = await fetch(this.dataset.cartUrl); if (!cartResponse.ok) throw Error('Os itens foram adicionados. Abra o carrinho para conferir.');
        const cart = await cartResponse.json(); if (result.sections?.['mini-cart']) cart.sections = result.sections;
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated',{bubbles:true,detail:{cart}}));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true,detail:{cart,openMiniCart:this.dataset.cartType==='drawer'}}));
        status.textContent = 'Itens adicionados ao carrinho.';
      } catch (error) { status.textContent = added ? 'Os itens já foram adicionados. Abra o carrinho para conferir.' : error.message; }
      finally { this.busy = false; button.removeAttribute('aria-busy'); button.textContent = 'ADICIONAR ITENS'; this.updateSubtotal(); }
    }
  }
  customElements.define('sf-complementary-products', SoulFeBundlePicker);
})();
